export const CONFIGURACION_PATH = '/configuracion'
export const CONFIGURACION_MENU_LABEL = 'Configuración'
export const STOCK_NEGATIVO_LABEL = 'Permitir stock negativo'
export const STOCK_NEGATIVO_HELP =
    'Las ventas pueden dejar el stock en negativo cuando no hay stock suficiente'

export const canAccessConfiguracion = (role) => role === 'ROLE_ADMIN'
